import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./Menu.css";
import "./Valises.css";

// Carte SET avec image : utilise setProduct.image si présent, sinon charge via GET /api/ProductV/image/:id
function SetCardWithImage({ setProduct, onSetClick }) {
  const [imageError, setImageError] = useState(false);
  const imageSrc = setProduct.image || `/api/ProductV/image/${setProduct._id}`;

  return (
    <div className="set-card" onClick={() => onSetClick(setProduct)}>
      <div className="card-image-area">
        {!imageError ? (
          <img
            src={imageSrc}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            onError={() => setImageError(true)}
          />
        ) : (
          <div style={{ width: "100%", height: "100%", background: "#e8eaed", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem", color: "#999" }}>S</div>
        )}
      </div>
      <div className="set-card">
        <span className="set-name">{setProduct.name}</span>
        {setProduct.price != null && (
          <span className="card-price">{Number(setProduct.price).toFixed(2)} DT</span>
        )}
        {setProduct.giftPoints > 0 && (
          <div className="product-points-badge">🎁 {setProduct.giftPoints}</div>
        )}
      </div>
    </div>
  );
}

function Valises() {
  const currentUser = useSelector((state) => state.AuthReducer?.user);

  const [menuData, setMenuData] = useState([]);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [additionItems, setAdditionItems] = useState([]);
  const [tableNumber, setTableNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [availableDiscounts, setAvailableDiscounts] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [newSubProductImage, setNewSubProductImage] = useState(null);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  // States pour le scan de codes-barres
  const [barcodeInput, setBarcodeInput] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [barcodeBuffer, setBarcodeBuffer] = useState("");

  // States pour l'annulation
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [adminCode, setAdminCode] = useState("");
  const [cancelBarcodeInput, setCancelBarcodeInput] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [billsHistory, setBillsHistory] = useState([]);
  const [nextBillNumber, setNextBillNumber] = useState("001");
  const [foundBill, setFoundBill] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]); // 🔥 NOUVEAU: Stocke tous les produits

  // ========================================
  // ÉTATS POUR L'AJOUT DE POINTS
  // ========================================
  const [showPointsModal, setShowPointsModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pointsLoading, setPointsLoading] = useState(false);
  const [isPointsQueued, setIsPointsQueued] = useState(false); // 🔥 NOUVEAU: Pour savoir si on a préparé l'ajout de points
  const [clientName, setClientName] = useState(""); // 🔥 NOUVEAU: Pour afficher le nom du client
  const [clientLoading, setClientLoading] = useState(false); // 🔥 NOUVEAU: Pour le chargement du nom

  // ========================================
  // ÉTATS POUR LES POINTS CADEAUX
  // ========================================
  const [giftPointsTotal, setGiftPointsTotal] = useState(0);
  const [giftPointsDetails, setGiftPointsDetails] = useState([]);

  // Codes administrateurs autorisés
  const ADMIN_CODES = ["98315003", "98707107", "admin17", "admin12"];

  // Normalise l'image pour l'affichage : data URL complète ou base64 seul → src utilisable par <img>
  const getImageSrc = (image) => {
    if (!image || typeof image !== "string") return null;
    const trimmed = image.trim();
    if (!trimmed) return null;
    if (trimmed.startsWith("data:")) return trimmed;
    return `data:image/jpeg;base64,${trimmed}`;
  };

  // 🔍 Fonction pour extraire l'ID de localisation
  const extractLocId = (loc) => {
    if (!loc) return null;
    
    // Si c'est déjà une string (ID)
    if (typeof loc === "string") return loc;
    
    // Cas MongoDB JSON : {$oid: "..."}
    if (loc.$oid) return loc.$oid;
    
    // Cas Objet Mongoose : {_id: "..."} ou {_id: {$oid: "..."}}
    if (loc._id) {
      if (typeof loc._id === "string") return loc._id;
      if (loc._id.$oid) return loc._id.$oid;
      if (typeof loc._id.toString === "function") {
        const s = loc._id.toString();
        if (s && s !== "[object Object]") return s;
      }
    }

    // Fallback toString() sur l'objet lui-même
    if (typeof loc.toString === "function") {
      const s = loc.toString();
      if (s && s !== "[object Object]") return s;
    }

    return null;
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        if (!currentUser) return;
        const token = localStorage.getItem("token");
        const authHeader = { Authorization: token ? `Bearer ${token}` : "" };
        const authorisedHeader = { Authorised: token };

        const userLocId = extractLocId(currentUser?.localisation);
        const locQuery = userLocId ? `?location=${userLocId}&activeOnly=true` : `?activeOnly=true`;

        const [productsRes, billsRes, locationsRes, discountsRes] = await Promise.all([
          axios.get("/api/ProductV/getProductV", {
            headers: authHeader,
            maxContentLength: 50 * 1024 * 1024,
            maxBodyLength: 50 * 1024 * 1024,
          }),
          axios.get("/api/BillsValises/getAllBillsV", { headers: authHeader }),
          // 🔥 Chargement des boutiques pour résoudre les noms depuis les IDs
          axios.get("/api/Locations/getAllLocations", { headers: authorisedHeader }),
          axios.get(`/api/discounts${locQuery}`, { headers: authorisedHeader }).catch(() => ({ data: { discounts: [] } }))
        ]);

        const products = productsRes.data;
        setMenuData(products);
        setAllProducts(products);
        setBillsHistory(billsRes.data);
        setLocations(locationsRes.data || []);
        setAvailableDiscounts(discountsRes.data?.discounts || []);

      } catch (err) {
        console.error("Erreur chargement données:", err.message);
      }
    };

    fetchAllData();
    getNextBillNumber();
  }, [currentUser]);

  // Rafraîchir le numéro de facture quand la date change
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      // Si minuit passé, regénérer les numéros
      if (now.getHours() === 0 && now.getMinutes() === 0) {
        console.log("🕛 Minuit - Regénération des numéros de facture");
        getNextBillNumber();
      }
    }, 60000); // Vérifier toutes les minutes

    return () => clearInterval(interval);
  }, [currentUser]);

  // 🔥 FONCTION ROBUSTE POUR TROUVER L'ID D'UN PRODUIT
  const findProductId = (productName) => {
    console.log(`🔍 Recherche ID pour: "${productName}"`);

    if (!productName) return null;

    // 1. Recherche dans les produits principaux
    const mainProduct = allProducts.find(p =>
      p.name && p.name.trim().toUpperCase() === productName.trim().toUpperCase()
    );

    if (mainProduct) {
      console.log(`✅ Produit principal trouvé: ${mainProduct._id}`);
      return mainProduct._id;
    }

    // 2. Recherche dans les sous-produits
    for (const product of allProducts) {
      if (product.subProductsV && Array.isArray(product.subProductsV)) {
        const subProduct = product.subProductsV.find(sp =>
          sp.name && sp.name.trim().toUpperCase() === productName.trim().toUpperCase()
        );

        if (subProduct) {
          console.log(`✅ Sous-produit trouvé: ${subProduct._id}`);
          return subProduct._id;
        }
      }
    }

    // 3. Recherche approximative (en cas de légères différences)
    for (const product of allProducts) {
      if (product.name && product.name.trim().toUpperCase().includes(productName.trim().toUpperCase())) {
        console.log(`✅ Produit trouvé (recherche approximative): ${product._id}`);
        return product._id;
      }

      if (product.subProductsV) {
        const subProduct = product.subProductsV.find(sp =>
          sp.name && sp.name.trim().toUpperCase().includes(productName.trim().toUpperCase())
        );

        if (subProduct) {
          console.log(`✅ Sous-produit trouvé (recherche approximative): ${subProduct._id}`);
          return subProduct._id;
        }
      }
    }

    console.log(`❌ Aucun ID trouvé pour: "${productName}"`);
    return null;
  };

  // ========================================
  // FONCTIONS POUR LES POINTS CADEAUX
  // ========================================

  // Fonction pour récupérer les points d'un sous-produit
  const getSubProductPoints = (subProductId) => {
    let points = 0;

    if (!menuData || menuData.length === 0 || !subProductId) return points;

    // Rechercher le sous-produit dans tous les produits
    for (const product of menuData) {
      if (product.subProductsV && Array.isArray(product.subProductsV)) {
        // 🔥 Utiliser String() pour assurer une comparaison robuste des IDs
        const subProduct = product.subProductsV.find(sp => String(sp._id) === String(subProductId));
        if (subProduct) {
          // 🔥 S'assurer que les points sont bien traités comme un nombre
          points = Number(subProduct.giftPoints) || 0;
          break;
        }
      }
    }

    return points;
  };

  // Fonction pour calculer le total des points cadeaux
  const calculateGiftPoints = () => {
    if (!additionItems || additionItems.length === 0) return 0;

    let totalPoints = 0;
    const details = [];

    additionItems.forEach(item => {
      // Si c'est un produit régulier
      if (!item.isSet) {
        const itemPoints = getSubProductPoints(item.id);
        const subTotalPoints = itemPoints * item.quantity;
        totalPoints += subTotalPoints;

        details.push({
          name: item.name,
          quantity: item.quantity,
          pointsPerUnit: itemPoints,
          totalPoints: subTotalPoints
        });
      }
      // Si c'est un SET avec des sous-produits
      else if (item.isSet && item.subProducts && item.subProducts.length > 0) {
        item.subProducts.forEach(sp => {
          const spPoints = getSubProductPoints(sp.id || sp._id);
          const spTotalPoints = spPoints; // Un seul par sous-produit dans un set
          totalPoints += spTotalPoints;

          details.push({
            name: `${item.name} - ${sp.name}`,
            quantity: 1,
            pointsPerUnit: spPoints,
            totalPoints: spTotalPoints
          });
        });
      }
    });

    setGiftPointsDetails(details);
    return totalPoints;
  };

  // Mettre à jour les points quand l'addition change
  useEffect(() => {
    const totalPoints = calculateGiftPoints();
    setGiftPointsTotal(totalPoints);
  }, [additionItems, menuData]);

  // Déterminer les catégories disponibles selon le rôle
  const getAvailableCategories = () => {
    if (!currentUser) return [];

    const role = currentUser.role;

    if (role === "userbagngo") {
      return ["VALISES", "SACS", "ACCESSOIRES", "SET"];
    } else if (role === "usertwinpark") {
      return ["JOUETS", "CANDY BAR"];
    } else if (role === "userespace") {
      return ["CANDY STORE", "PLAYSTATION"];
    }
    else if (role === "admin" || role === "useradmin") {
      return ["VALISES", "SACS", "ACCESSOIRES", "SET", "JOUETS", "CANDY BAR", "CANDY STORE", "PLAYSTATION"];
    }

    return [];
  };

  const availableCategories = getAvailableCategories();

  // Détection automatique des codes-barres
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }

      if (e.key === 'Enter' && barcodeBuffer.length > 3) {
        console.log("📷 Code-barres détecté automatiquement:", barcodeBuffer);
        handleBarcodeScan(barcodeBuffer.trim());
        setBarcodeBuffer("");
        e.preventDefault();
        return;
      }

      if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
        setBarcodeBuffer(prev => prev + e.key);

        const timer = setTimeout(() => {
          setBarcodeBuffer("");
        }, 100);

        return () => clearTimeout(timer);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [barcodeBuffer]);

  // Fonction pour récupérer l'historique des factures
  const fetchBillsHistory = async () => {
    try {
      const response = await axios.get("/api/BillsValises/getAllBillsV");
      setBillsHistory(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des factures:", error);
    }
  };

  const getNextBillNumber = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      const locationId = extractLocId(currentUser?.localisation);

      if (!locationId) {
        console.warn("⚠️ Localisation non trouvée, utilisation du fallback");
        setNextBillNumber("001");
        return;
      }

      console.log(`🔍 Génération numéro facture: ${today} - ${currentUser?.localisation?.name}`);

      const response = await axios.post("/api/BillsValises/generateNextBillNumber", {
        locationId: locationId
      });

      if (response.data.success) {
        setNextBillNumber(response.data.nextBillNumber);
        console.log(`✅ ${currentUser?.localisation?.name}: Facture N° ${response.data.nextBillNumber}`);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("❌ Erreur génération numéro facture:", error);
      // Fallback robuste
      const today = new Date().toISOString().split('T')[0];
      const locationKey = `lastBillDate_${currentUser?.localisation?._id || "default"}`;
      const counterKey = `dailyBillCounter_${currentUser?.localisation?._id || "default"}`;

      const lastDate = localStorage.getItem(locationKey);
      let counter = 1;

      if (lastDate === today) {
        counter = parseInt(localStorage.getItem(counterKey) || '0') + 1;
      } else {
        localStorage.setItem(locationKey, today);
      }

      localStorage.setItem(counterKey, counter.toString());
      const billNumber = counter.toString().padStart(3, '0');
      setNextBillNumber(billNumber);
      console.log(`📊 Numéro facture (fallback): ${billNumber}`);
    }
  };

  const handleBarcodeScan = async (barcode) => {
    if (!barcode || barcode.length < 3) return;

    console.log("📷 SCAN - Code:", barcode, "User:", currentUser?.name, "Loc:", currentUser?.localisation?.name);

    setIsScanning(true);

    try {
      // 🔥 APPROCHE 1: Recherche directe dans les données locales
      const userLocId = extractLocId(currentUser?.localisation);
      console.log("🔍 Recherche locale - Localisation utilisateur:", userLocId);

      let foundSubProduct = null;
      let foundProduct = null;

      // Recherche dans tous les produits chargés
      for (const product of menuData) {
        if (product.subProductsV && Array.isArray(product.subProductsV)) {
          for (const subProduct of product.subProductsV) {
            if (subProduct.barcode === barcode) {
              console.log("🔍 Produit trouvé avec code-barres:", subProduct.name);

              // Vérifier la localisation
              const subProductLocations = subProduct.localisations || [subProduct.localisation].filter(Boolean);
              console.log("   Localisations du produit:", subProductLocations);

              const isInUserLocation = subProductLocations.some(loc => {
                const locId = extractLocId(loc);
                const match = locId === userLocId;
                console.log(`   → ${locId} === ${userLocId} : ${match}`);
                return match;
              });

              if (isInUserLocation) {
                foundSubProduct = subProduct;
                foundProduct = product;
                console.log("✅ PRODUIT CORRECT TROUVÉ DANS LA BONNE LOCALISATION!");
                break;
              } else {
                console.log("⚠️ Produit trouvé mais mauvaise localisation");
              }
            }
          }
        }
        if (foundSubProduct) break;
      }

      // 🔥 APPROCHE 2: Si pas trouvé localement, utiliser l'API avec filtre
      if (!foundSubProduct) {
        console.log("🔄 Produit non trouvé localement, appel API...");

        const response = await axios.post('/api/ProductV/getSubProductByBarcode', {
          barcode: barcode,
          localisation: userLocId // 🔥 ENVOYER LA LOCALISATION
        });

        if (response.data) {
          foundSubProduct = response.data;
          console.log("✅ Produit trouvé via API:", foundSubProduct.name);
        }
      }

      if (!foundSubProduct) {
        throw new Error("Aucun produit trouvé avec ce code-barres dans votre localisation");
      }

      console.log("🎯 Produit final:", foundSubProduct.name);
      console.log("   Prix:", foundSubProduct.price);
      console.log("   ID:", foundSubProduct._id);

      handleSubProductClick(
        foundSubProduct._id,
        foundSubProduct.name,
        foundSubProduct.price,
        foundProduct?._id || foundSubProduct.product?._id,
        foundSubProduct.localisation || foundSubProduct.localisations?.[0]
      );

      setBarcodeInput(`✅ ${foundSubProduct.name}`);
      setTimeout(() => setBarcodeInput(""), 2000);

    } catch (error) {
      console.error("❌ ERREUR SCAN:", error);
      console.error("   Détails:", error.response?.data || error.message);

      setBarcodeInput(`❌ Erreur: ${error.message}`);
      setTimeout(() => setBarcodeInput(""), 4000);
    } finally {
      setIsScanning(false);
    }
  };


  const handleManualBarcodeInput = async () => {
    if (barcodeInput.length > 3) {
      await handleBarcodeScan(barcodeInput.trim());
    }
  };

  const filteredProducts = selectedCategory
    ? menuData.filter((product) => product.category === selectedCategory)
    : [];

  const toggleSubProducts = (productId) => {
    setSelectedProduct((prev) => (prev === productId ? null : productId));
  };

  const handleSubProductClick = (
    subProductId,
    subProductName,
    price,
    parentDealId,
    localisation = null
  ) => {
    const parentDeal = menuData.find(
      (product) => product._id === parentDealId && product.category === "DEALS"
    );

    if (parentDeal) {
      const existingDealIndex = additionItems.findIndex(
        (item) => item.isDeal && item.dealId === parentDeal._id
      );

      if (existingDealIndex >= 0) {
        setAdditionItems((prev) =>
          prev.map((item, index) =>
            index === existingDealIndex
              ? {
                ...item,
                subProducts: [
                  ...item.subProducts,
                  {
                    id: subProductId,
                    name: subProductName,
                    price,
                    parentDealId: parentDeal._id,
                    localisation: extractLocId(localisation)
                  },
                ],
              }
              : item
          )
        );
      } else {
        setAdditionItems((prev) => [
          ...prev,
          {
            id: parentDeal._id,
            dealId: parentDeal._id,
            name: parentDeal.name,
            price: parentDeal.price,
            quantity: 1,
            isDeal: true,
            localisation: extractLocId(localisation || parentDeal.localisation),
            subProducts: [
              {
                id: subProductId,
                name: subProductName,
                price,
                parentDealId: parentDeal._id,
                localisation: extractLocId(localisation)
              },
            ],
          },
        ]);
      }
    } else {
      const existingItemIndex = additionItems.findIndex(
        (item) => !item.isDeal && item.id === subProductId
      );

      if (existingItemIndex >= 0) {
        setAdditionItems((prev) =>
          prev.map((item, index) =>
            index === existingItemIndex
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        );
      } else {
        setAdditionItems((prev) => [
          ...prev,
          {
            id: subProductId,
            name: subProductName,
            price,
            quantity: 1,
            isDeal: false,
            localisation: extractLocId(localisation)
          },
        ]);
      }
    }
  };

  const handleSetClick = (setProduct) => {

    const existingSetIndex = additionItems.findIndex(
      (item) => item.isSet && item.setId === setProduct._id
    );

    if (existingSetIndex >= 0) {
      setAdditionItems((prev) =>
        prev.map((item, index) =>
          index === existingSetIndex
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      const subProductsWithIds = (setProduct.subProductsV || []).map(sp => ({
        _id: sp._id,
        id: sp._id,
        name: sp.name,
        price: sp.price
      }));

      setAdditionItems((prev) => [
        ...prev,
        {
          id: setProduct._id,
          setId: setProduct._id,
          name: setProduct.name,
          price: setProduct.price,
          quantity: 1,
          isSet: true,
          localisation: extractLocId(setProduct.localisation),
          subProducts: subProductsWithIds,
        },
      ]);
    }
  };

  const calculateTotalTTC = () => {
    const total = additionItems?.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    const discountedTotal = total - (total * discount) / 100;
    return discountedTotal.toFixed(2);
  };

  const calculateTotal = () => {
    const total = additionItems?.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    const discountedTotal = (total - (total * discount) / 100) / 1.07;
    return discountedTotal.toFixed(2);
  };

  const calculateTva = () => {
    const tva = additionItems?.reduce(
      (sum, item) => sum + item.price * item.quantity * 0.07,
      0
    );
    return tva.toFixed(2);
  };

  const printAddition = (billNumber) => {
    const userLocId = extractLocId(currentUser?.localisation);
    
    // 🔥 RÉSOLUTION DU NOM : priorité name > lookup dans locations > fallback
    let locationName = "Localisation inconnue";

    const rawLoc = currentUser?.localisation;

    if (rawLoc) {
      if (typeof rawLoc === "object" && rawLoc.name) {
        // Objet peuplé : { _id, name }
        locationName = rawLoc.name;
      } else {
        // Utilisation de extractLocId pour gérer les objets de type {_id: "..."} ou {$oid: "..."}
        const extractedIdOrName = extractLocId(rawLoc);
        
        if (extractedIdOrName) {
          // Chercher l'ID dans la liste locations chargée
          const foundLoc = locations.find(
            (l) => l._id === extractedIdOrName || String(l._id) === extractedIdOrName
          );
          
          if (foundLoc && foundLoc.name) {
            locationName = foundLoc.name;
          } else if (!/^[0-9a-fA-F]{24}$/.test(extractedIdOrName)) {
            // Si ce n'est pas un ID MongoDB (ex: 24 caractères hexadécimaux), c'est probablement un nom direct
            locationName = extractedIdOrName;
          }
        }
      }
    }

    if (locationName === "Localisation inconnue" && selectedLocation?.name) {
      locationName = selectedLocation.name;
    }

    if (!locationName) {
      locationName = "Localisation inconnue";
    }

    const confirmationDate = new Date().toLocaleString();

    // 🔥 MAPPING EXACT DES LOGOS PAR LOCALISATION
    const getLogoByLocation = (location) => {
      const logoMapping = {
        // Twin Park
        "TP-Manar City": "/twinpark.png",
        "TP-Tunisia Mall": "/twinpark.png",
        "TP-Jardins d'El Menzah": "/twinpark.png",

        // Bag'N Go
        "BNG-Tunisia Mall": "/Logo-BnG.png",

        // Spintoss
        "Spintoss-Les Jardins": "/spintoss.png",
        "Spintoss-Tunisia Mall": "/spintoss.png",

        // E-Space
        "E-Space Tunisia Mall": "/Espace.png",

        // Logo par défaut
        "Localisation inconnue": "/LOGOTASKOPOS1.png"
      };

      return logoMapping[location] || "/LOGOTASKOPOS1.png";
    };

    const logoUrl = getLogoByLocation(locationName);

    // 🔥 CRÉER UN CODE UNIQUE TOTALEMENT ROBUSTE (Full Timestamp + Random)
    const timestampHex = Date.now().toString(16).toUpperCase();
    const randomHex = Math.random().toString(16).substring(2, 6).toUpperCase();
    const uniqueCode = `Kdo${giftPointsTotal}-${billNumber}-${timestampHex}${randomHex}`;

    // 🔥 STRUCTURE OPTIMISÉE POUR COMPATIBILITÉ ET UNICITÉ (Format Spintoss)
    const today = new Date().toISOString().split('T')[0];
    const qrData = {
      c: uniqueCode, // code unique
      p: giftPointsTotal,// points
      b: `${billNumber}-${today}`, // bill number enrichi pour éviter les doublons en DB
      l: locationName.substring(0, 3).toUpperCase(), // code localisation
      d: today, // date
      t: parseFloat(calculateTotalTTC()),         // total TTC
      m: paymentMethod?.substring(0, 1) || "C"    // mode de paiement
    };

    // Convertir en chaîne JSON compacte
    const qrDataString = JSON.stringify(qrData);

    console.log("🔍 Données QR code (Logic Spintoss Final2):", qrDataString);
    console.log("📏 Longueur:", qrDataString.length, "caractères");
    console.log("🎁 Points cadeaux totaux:", giftPointsTotal);

    // 🔥 URL ENCODÉE - Taille augmentée pour meilleure scannabilité
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrDataString)}&color=7B1FA2&ecc=H`;

    const printableContent = `
    <div style="font-family: 'Arial', sans-serif; text-align: center; max-width: 300px; margin: 0 auto; padding: 10px;">
      <!-- 🔥 LOGO DYNAMIQUE PAR LOCALISATION -->
      <div style="margin-bottom: 10px;">
        <img src="${logoUrl}" 
             alt="Logo ${locationName}" 
             style="max-width: 80px; max-height: 60px; display: block; margin: 0 auto;"
             onerror="this.style.display='none'">
      </div>
      
      <h1 style="margin: 5px 0; font-size: 18px; color: #333;">${locationName.toUpperCase()}</h1>
      <h3 style="margin: 5px 0; color: #666; font-size: 14px;">Reçu de paiement</h3>
      
      <div style="border-top: 2px solid #333; margin: 10px 0;"></div>
      
      <p style="margin: 3px 0; font-size: 12px;"><strong>Facture N°:</strong> ${billNumber}</p>
      <p style="margin: 3px 0; font-size: 12px;"><strong>Date:</strong> ${confirmationDate}</p>
      
      <div style="border-top: 1px dashed #ccc; margin: 10px 0;"></div>
      
      <!-- Articles -->
      <div style="text-align: left; margin: 10px 0;">
        ${additionItems
        .map(
          (item) => {
            const itemPoints = getSubProductPoints(item.id) * item.quantity;
            return `
            <div style="display: flex; justify-content: space-between; margin: 5px 0; font-size: 12px;">
              <div style="flex: 2;">
                ${item.name} x${item.quantity}
                ${itemPoints > 0 ? `<div style="font-size: 10px; color: #7B1FA2;">🎁 ${itemPoints} pts</div>` : ''}
              </div>
              <div style="flex: 1; text-align: right;">${(item.price * item.quantity).toFixed(2)} DT</div>
            </div>`;
          }
        )
        .join("")}
      </div>
      
      <div style="border-top: 1px dashed #ccc; margin: 10px 0;"></div>
      
      <!-- Totaux -->
      <div style="text-align: left; margin: 10px 0; font-size: 12px;">
        <div style="display: flex; justify-content: space-between; margin: 3px 0;">
          <span>Total HT:</span>
          <span>${calculateTotal()} DT</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin: 3px 0;">
          <span>TVA:</span>
          <span>${calculateTva()} DT</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin: 3px 0; font-weight: bold;">
          <span>Total TTC:</span>
          <span>${calculateTotalTTC()} DT</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin: 3px 0;">
          <span>Remise:</span>
          <span>${discount}%</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin: 3px 0;">
          <span>Paiement:</span>
          <span>${paymentMethod}</span>
        </div>
      </div>
      
      <!-- 🔥 QR CODE AVEC PRODUITS ET POINTS CADEAUX -->
      <div style="border-top: 2px solid #333; margin: 15px 0; padding-top: 10px;">
        <p style="font-size: 11px; color: #666; margin-bottom: 5px;">
          🎁 QR Code Points Cadeaux
        </p>
        ${giftPointsTotal > 0 ? `
          <p style="font-size: 14px; color: #4CAF50; font-weight: bold; margin: 5px 0;">
            ${giftPointsTotal} Points Kdo
          </p>
          <p style="font-size: 10px; color: #666; margin: 5px 0;">
            Code: ${uniqueCode}
          </p>
        ` : `
          <p style="font-size: 11px; color: #999; margin: 5px 0;">
            Aucun point cadeau
          </p>
        `}
        <div style="width: 100px; height: 100px; margin: 10px auto;">
          <img src="${qrCodeUrl}" 
               alt="QR Code Facture ${billNumber}" 
               style="width: 100px; height: 100px; border: 1px solid #eee; background: white;"
               onerror="
                 console.error('Erreur QR code, essai format texte simple');
                 // Fallback en texte simple si JSON échoue
                 const simpleText = 'Kdo${billNumber}|P${giftPointsTotal}|T${calculateTotalTTC()}';
                 this.src = 'https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=' + encodeURIComponent(simpleText);
               ">
        </div>
        <p style="font-size: 10px; color: #888; margin-top: 3px;">
          ${additionItems.length} article(s) • ${calculateTotalTTC()} DT
        </p>
      </div>
      
      <div style="margin-top: 15px; font-size: 11px; color: #666;">
        <div>Merci pour votre visite !</div>
        <div style="margin-top: 5px;">À bientôt</div>
      </div>
    </div>
  `;

    const printWindow = window.open("", "_blank", "width=350,height=600,left=100,top=100");
    if (!printWindow) {
      console.error("Popup bloquée par le navigateur");
      alert("⚠️ L'impression du ticket a été bloquée par le navigateur. Veuillez autoriser les pop-ups pour ce site dans la barre d'adresse pour pouvoir imprimer les tickets.");
      return;
    }
    
    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Facture ${billNumber}</title>
        <style>
          @media print {
            body { margin: 0; padding: 10px; }
            @page { margin: 0; }
          }
          * { box-sizing: border-box; }
        </style>
      </head>
      <body>
        ${printableContent}
        <script>
          // Afficher les données du QR code pour debug
          console.log("🎯 Facture ${billNumber}");
          console.log("📊 Données QR (JSON):", ${JSON.stringify(qrData)});
          
          window.onload = function() {
            // Attendre que le QR code se charge
            const qrImg = document.querySelector('img[alt^="QR Code"]');
            
            if (qrImg) {
              // Vérifier si déjà chargé
              if (qrImg.complete && qrImg.naturalHeight !== 0) {
                console.log("✅ QR code déjà chargé");
                setTimeout(printNow, 500);
              } else {
                qrImg.onload = function() {
                  console.log("✅ QR code chargé avec succès");
                  setTimeout(printNow, 500);
                };
                qrImg.onerror = function() {
                  console.warn("⚠️ QR code non chargé, impression sans");
                  setTimeout(printNow, 500);
                };
                
                // Timeout de sécurité
                setTimeout(printNow, 2000);
              }
            } else {
              setTimeout(printNow, 1000);
            }
            
            function printNow() {
              console.log("🖨️ Impression...");
              window.print();
              setTimeout(function() {
                window.close();
              }, 1000);
            }
          };
        </script>
      </body>
    </html>
  `);
    printWindow.document.close();
  };

  const resetVars = () => {
    setAdditionItems([]);
    setTableNumber("");
    setPaymentMethod(null);
    setDiscount(0);
    setSelectedDiscount(null);
    setDiscountCode("");
    alert("Paiement effectué avec succès !");
  };

  const processStockDeduction = async (productId, quantity) => {
    try {
      const requestData = {
        products: [
          {
            id: productId,
            quantity: quantity,
          },
        ],
      };

      console.log("📤 Déduction envoyée:", requestData);

      const response = await axios.post("/api/StockV/reduceStock", requestData, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("📥 Réponse complète du backend:", response.data);

      // 🔥 CORRECTION PRINCIPALE ICI :
      // On ne regarde plus seulement 'response.data.success'
      // Le backend peut renvoyer succès partiel même si success = false

      if (response.data && response.data.results) {
        const result = response.data.results[0];
        console.log("📊 Résultat détaillé:", result);

        // ANALYSE INTELLIGENTE DU RÉSULTAT
        // 1. Si le résultat individuel indique le succès
        // 2. OU si le message global indique "Déduction effectuée"
        // 3. OU si la quantité a été réduite (newQuantity < previousQuantity)

        const isSuccessful =
          result.success === true ||
          (response.data.message && response.data.message.includes("Déduction effectuée")) ||
          (result.newQuantity !== undefined && result.previousQuantity !== undefined &&
            result.newQuantity < result.previousQuantity);

        if (isSuccessful) {
          console.log(`✅ Stock déduit pour ${productId}`);
          return {
            success: true, // On retourne TRUE au frontend
            details: result,
            message: response.data.message || "Déduction réussie"
          };
        } else {
          // Cas d'erreur réelle
          console.warn(`⚠️ Déduction échouée pour ${productId}:`, result.status);
          return {
            success: false,
            error: result.status || "Erreur inconnue",
            details: result
          };
        }
      }

      // Si le format de réponse est inattendu
      console.warn(`⚠️ Réponse invalide pour ${productId}:`, response.data);
      return {
        success: false,
        error: "Format de réponse invalide",
        details: response.data
      };

    } catch (error) {
      console.error("❌ Erreur processStockDeduction:", error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  };

  // Fonction pour restaurer le stock lors de l'annulation - VERSION CORRIGÉE
  const restoreStock = async (productId, quantity) => {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        console.error("❌ Aucun token trouvé");
        return false;
      }

      const requestData = {
        products: [
          {
            id: productId,
            quantity: quantity,
          },
        ]
      };

      console.log("📤 Restauration de stock:", {
        ...requestData,
        userLocation: currentUser?.localisation,
        userId: currentUser?._id,
        tokenPresent: !!token
      });

      const response = await axios.post("/api/StockV/restoreStock", requestData, {
        headers: {
          "Content-Type": "application/json",
          "Authorised": token // 🔥 Utiliser le bon nom de header
        },
      });

      console.log("📥 Réponse restauration:", response.data);

      if (response.data && response.data.success) {
        console.log(`✅ Stock restauré:`, {
          productId: productId,
          quantity: quantity,
          location: response.data.userLocation,
          results: response.data.results
        });

        // 🔥 DÉCLENCHER LE RAFRAÎCHISSEMENT DU STOCK
        console.log("🔄 Déclenchement rafraîchissement stock...");
        localStorage.setItem('stock-needs-refresh', Date.now().toString());
        window.dispatchEvent(new Event('stock-updated'));

        return true;
      } else {
        console.warn(`⚠️ Échec de restauration:`, response.data);
        return false;
      }
    } catch (error) {
      console.error("❌ Erreur restoreStock:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.config?.headers // 🔥 Ajouter pour debug
      });
      return false;
    }
  };

  // 🔥 CORRECTION COMPLÈTE DE LA FONCTION D'ANNULATION
  const cancelArticle = async () => {
    if (!adminCode.trim()) {
      alert("Veuillez saisir le code administrateur");
      return;
    }

    if (!ADMIN_CODES.includes(adminCode)) {
      alert("Code administrateur invalide");
      return;
    }

    if (!foundBill) {
      alert("Veuillez d'abord trouver la facture");
      return;
    }

    if (!cancelBarcodeInput.trim()) {
      alert("Veuillez sélectionner un article");
      return;
    }

    if (!cancelReason.trim()) {
      alert("Veuillez sélectionner un motif d'annulation");
      return;
    }

    try {
      setLoading(true);

      console.log("🔍 ID sélectionné:", cancelBarcodeInput);
      console.log("📋 Facture trouvée:", foundBill.billNumber);
      console.log("👤 Utilisateur:", currentUser);

      // Recherche de l'article dans la facture
      const articleToCancel = foundBill.items.find(item =>
        item._id.toString() === cancelBarcodeInput
      );

      if (!articleToCancel) {
        alert("❌ Article non trouvé dans la facture");
        return;
      }

      console.log("✅ Article trouvé:", articleToCancel);

      let productId = null;

      // 🔥 ESSAI 1: Extraire l'ID depuis l'article de la facture
      if (articleToCancel.id) {
        if (typeof articleToCancel.id === 'object') {
          productId = articleToCancel.id._id || articleToCancel.id.$oid || articleToCancel.id.toString();
        } else if (typeof articleToCancel.id === 'string') {
          productId = articleToCancel.id;
        }
      }

      // 🔥 ESSAI 2: Recherche dynamique par nom
      if (!productId && articleToCancel.name) {
        console.log(`🔍 Recherche dynamique de l'ID pour: "${articleToCancel.name}"`);
        productId = findProductId(articleToCancel.name);
      }

      // 🔥 ESSAI 3: Mapping de secours pour les produits courants
      if (!productId) {
        console.warn("⚠️ Utilisation du mapping de secours");
        const backupMapping = {
          "OZUF": "690725a2c271f61774736fa1",
          "OEUF": "6905ee87017e37ec89fd184b",
          "LAIT": "6905ee87017e37ec89fd184b", // Remplacez par le vrai ID de LAIT
          "VACHE": "6905ee87017e37ec89fd184b",
          // Ajoutez d'autres produits courants ici
        };

        productId = backupMapping[articleToCancel.name.toUpperCase()];
      }

      // 🔥 DERNIER RECOURS: Demander l'ID manuellement
      if (!productId) {
        const manualId = prompt(
          `ID non trouvé pour "${articleToCancel.name}".\n\nVeuillez saisir l'ID manuellement:`,
          ""
        );

        if (manualId && manualId.trim()) {
          productId = manualId.trim();
          console.log(`✅ ID saisi manuellement: ${productId}`);
        } else {
          alert("❌ Annulation impossible sans ID produit");
          return;
        }
      }

      console.log("🔄 ID produit final:", productId);

      // 🔥 ÉTAPE 1: Restaurer le stock
      console.log("🔄 Étape 1: Restauration du stock...");
      const stockSuccess = await restoreStock(productId, articleToCancel.quantity);

      if (!stockSuccess) {
        console.warn("⚠️ Problème lors de la restauration du stock");
        // Demander confirmation avant de continuer
        const shouldContinue = window.confirm(
          "⚠️ Problème lors de la restauration du stock.\n\n" +
          "Voulez-vous quand même annuler l'article dans la facture ?\n" +
          "(Le stock ne sera pas restauré)"
        );

        if (!shouldContinue) {
          setLoading(false);
          return;
        }
      }

      // 🔥 ÉTAPE 2: Annuler l'article dans la facture
      console.log("🔄 Étape 2: Annulation dans la facture...");

      // Préparer les données pour l'annulation
      const cancelData = {
        billId: foundBill._id,
        barcode: productId, // Utiliser l'ID du produit
        cancelReason: cancelReason
      };

      console.log("📤 Données d'annulation:", cancelData);

      // Récupérer le token
      const token = localStorage.getItem('token');
      if (!token) {
        alert("❌ Token non trouvé. Veuillez vous reconnecter.");
        setLoading(false);
        return;
      }

      // Envoyer la requête d'annulation
      const response = await axios.post('/api/BillsValises/cancelArticle', cancelData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorised': token // 🔥 Utiliser 'Authorised' comme dans les autres appels
        }
      });

      console.log("📥 Réponse annulation:", response.data);

      if (response.data.success) {
        // Afficher le nom de l'article annulé
        const cancelledArticleName = response.data.cancelledArticle?.productName || articleToCancel.name;

        alert(`✅ Article annulé: ${cancelledArticleName}\n\n` +
          `Facture N°: ${foundBill.billNumber}\n` +
          `Quantité: ${articleToCancel.quantity}\n` +
          `Motif: ${cancelReason}`);

        // Imprimer le reçu d'annulation
        printCancelReceipt(cancelledArticleName);

        // Réinitialiser
        setShowCancelModal(false);
        setFoundBill(null);
        setInvoiceDate("");
        setInvoiceNumber("");
        setCancelBarcodeInput("");
        setCancelReason("");
        setAdminCode("");

        // Rafraîchir l'historique des factures
        await fetchBillsHistory();

      } else {
        alert("❌ Erreur lors de l'annulation: " + (response.data.message || "Erreur inconnue"));
      }

    } catch (error) {
      console.error("❌ Erreur lors de l'annulation:", error);

      // Messages d'erreur plus détaillés
      if (error.response?.status === 401) {
        alert("❌ Session expirée. Veuillez vous reconnecter.");
      } else if (error.response?.status === 404) {
        alert("❌ Facture ou article non trouvé. " + (error.response.data?.message || ""));
      } else if (error.response?.data?.message) {
        alert("❌ Erreur: " + error.response.data.message);
      } else {
        alert("❌ Erreur lors de l'annulation de l'article: " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const confirmAddition = async () => {
    if (!paymentMethod) return alert("Choisissez un mode de paiement.");

    setLoading(true);
    try {
      // 🔥 CORRECTION: Préparer les données de la facture AVANT déduction
      const bill = {
        items: additionItems.map(item => {
          // 🔥 CORRECTION: Assurer que tous les champs requis sont présents
          const billItem = {
            id: item.id || item._id,
            name: item.name,
            price: parseFloat(item.price) || 0,
            quantity: parseInt(item.quantity) || 0,
            isDeal: item.isDeal || false,
            isSet: item.isSet || false,
            unit: item.unit || "Pièces"
          };

          // Ajouter les sous-produits si présents
          if (item.subProducts && item.subProducts.length > 0) {
            billItem.subProducts = item.subProducts.map(sp => ({
              id: sp.id || sp._id,
              name: sp.name || "Sous-produit",
              price: parseFloat(sp.price) || 0
            }));
          }

          return billItem;
        }),
        paymentMethod,
        discount: parseFloat(discount) || 0,
        discountPercentage: parseFloat(discount) || 0,
        discountName: selectedDiscount ? selectedDiscount.name : (discount > 0 ? `Remise ${discount}%` : ""),
        discountId: selectedDiscount?._id || null,
        total: parseFloat(calculateTotal()) || 0,
        tva: parseFloat(calculateTva()) || 0,
        billNumber: nextBillNumber,
        date: new Date(),
        confirmationDate: new Date(),
        userId: currentUser?._id,
        user: currentUser?._id,
        userName: currentUser?.name
      };

      // 🔥 CORRECTION LOCALISATION: Plus robuste
      const currentUserLocId = extractLocId(currentUser?.localisation);
      const itemsLocId = additionItems.find(item => item.localisation)?.localisation;
      
      bill.localisation = currentUserLocId || itemsLocId || null;

      console.log("📍 Localisation finale de la facture:", bill.localisation);

      console.log("📝 Création facture:", JSON.stringify(bill, null, 2));
      console.log("📦 Articles à déduire:", additionItems);

      // 🔥 DÉDUCTION DU STOCK (optionnelle, on continue même en cas d'erreur)
      try {
        await processStockDeductions();
      } catch (stockError) {
        console.warn("⚠️ Erreur déduction stock, continuation...:", stockError.message);
        // Demander confirmation
        const shouldContinue = window.confirm(
          "Problème lors de la déduction du stock.\n\n" +
          "Voulez-vous quand même créer la facture ?\n" +
          "(Le stock ne sera pas mis à jour)"
        );

        if (!shouldContinue) {
          setLoading(false);
          return;
        }
      }

      // 🔥 CRÉATION DE LA FACTURE avec gestion d'erreur détaillée
      console.log("📤 Envoi de la facture au serveur...");

      const res = await axios.post("/api/BillsValises/createBillV", bill, {
        headers: {
          'Content-Type': 'application/json',
          'Authorised': localStorage.getItem('token')
        }
      });

      console.log("📥 Réponse création facture:", res.data);

      if (res.data && (res.data.success === true || res.status === 200 || res.status === 201)) {
        console.log(`✅ Facture ${nextBillNumber} enregistrée.`);

        // Déclencher le rafraîchissement du stock
        console.log("🔄 Déclenchement du rafraîchissement du stock...");
        localStorage.setItem('stock-needs-refresh', Date.now().toString());

        printAddition(nextBillNumber);

        // 🔥 AJOUT: Envoyer les points mis en attente
        if (isPointsQueued) {
          await sendQueuedPoints(nextBillNumber);
        }

        await getNextBillNumber();

        resetVars();

        // 🔥 SUCCÈS: Message de confirmation
        alert(`✅ Facture ${nextBillNumber} créée avec succès !\n\n` +
          `Montant: ${calculateTotalTTC()} DT\n` +
          `Mode de paiement: ${paymentMethod}`);
      } else {
        throw new Error(res.data?.message || "Erreur inconnue lors de la création");
      }
    } catch (err) {
      console.error("❌ Erreur lors du paiement:", err);
      console.error("❌ Détails erreur:", err.response?.data);

      // 🔥 MESSAGE D'ERREUR AMÉLIORÉ
      let errorMessage = "Erreur lors du paiement";

      if (err.response?.data) {
        const errorData = err.response.data;
        if (errorData.errors) {
          // Erreurs de validation Mongoose
          const validationErrors = Object.values(errorData.errors)
            .map(e => e.message || e)
            .join('\n• ');
          errorMessage = `Erreurs de validation:\n• ${validationErrors}`;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      alert(`❌ ${errorMessage}\n\nVérifiez la console pour plus de détails.`);
    } finally {
      setLoading(false);
    }
  };

  const processStockDeductions = async () => {
    console.log("🔄 Début de la déduction de stock...");

    for (const item of additionItems) {
      console.log(`📦 Traitement: ${item.name} (x${item.quantity})`);

      if (item.isSet && item.subProducts?.length > 0) {
        // Cas des SETs
        console.log(`🔧 SET détecté: ${item.name}`);
        for (const subProduct of item.subProducts) {
          const productId = subProduct._id || subProduct.id;
          console.log(`   - Sous-produit: ${subProduct.name} (ID: ${productId})`);

          if (productId) {
            const result = await processStockDeduction(productId, item.quantity);
            if (!result.success) {
              console.error(`❌ Échec déduction pour ${subProduct.name}:`, result);
              // 🔥 CORRECTION: Continuer même en cas d'échec pour un sous-produit
            } else if (result.warning) {
              console.warn(`⚠️ Avertissement pour ${subProduct.name}:`, result.warning);
            }
          } else {
            console.error(`❌ ID manquant pour sous-produit: ${subProduct.name}`);
          }
        }
      } else if (item.isDeal && item.subProducts?.length > 0) {
        // Cas des DEALs
        console.log(`🔧 DEAL détecté: ${item.name}`);
        for (const subProduct of item.subProducts) {
          const productId = subProduct.id;
          console.log(`   - Sous-produit: ${subProduct.name} (ID: ${productId})`);

          if (productId) {
            const result = await processStockDeduction(productId, item.quantity);
            if (!result.success) {
              console.error(`❌ Échec déduction pour ${subProduct.name}:`, result);
            } else if (result.warning) {
              console.warn(`⚠️ Avertissement pour ${subProduct.name}:`, result.warning);
            }
          } else {
            console.error(`❌ ID manquant pour sous-produit: ${subProduct.name}`);
          }
        }
      } else {
        // Cas des produits simples
        const productId = item.id;
        console.log(`🔧 Produit simple: ${item.name} (ID: ${productId})`);

        if (productId) {
          const result = await processStockDeduction(productId, item.quantity);
          if (!result.success) {
            console.error(`❌ Échec déduction pour ${item.name}:`, result);
            // 🔥 CORRECTION: Demander à l'utilisateur s'il veut continuer

          } else if (result.warning) {
            console.warn(`⚠️ Avertissement pour ${item.name}:`, result.warning);
          }
        } else {
          console.error(`❌ ID manquant pour produit: ${item.name}`);
        }
      }
    }

    console.log("✅ Déduction de stock terminée");
    return true; // 🔥 TOUJOURS retourner true sauf si erreur critique
  };
  const deleteItem = (id) => {
    setAdditionItems((prev) => prev.filter((item) => item.id !== id));
  };

  const modifyItem = (id, newQuantity) => {
    if (newQuantity < 1) return;
    setAdditionItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const handlePaymentMethod = (method) => {
    setPaymentMethod(method);
  };

  const applyDiscount = (percentage) => {
    setDiscount(percentage);
  };

  const validateDiscountCode = () => {
    const isValidCode = (code) => {
      const regex = /^(\d{4})-(2023)$/;
      const match = code.match(regex);
      if (match) {
        const part1 = parseInt(match[1], 10);
        return part1 >= 1 && part1 <= 1000;
      }
      return false;
    };

    if (isValidCode(discountCode)) {
      setDiscount(10);
      alert("Code de réduction appliqué !");
    } else {
      alert("Code invalide.");
    }
  };

  const searchBill = async () => {
    if (!invoiceDate || !invoiceNumber) {
      alert("Veuillez saisir la date et le numéro de facture");
      return;
    }

    setSearchLoading(true);
    try {
      console.log("🔍 Recherche facture - Utilisateur:", {
        name: currentUser?.name,
        location: currentUser?.localisation?.name,
        locationId: currentUser?.localisation?._id
      });

      // 🔥 SIMPLIFICATION: NE PAS envoyer locationId, le backend le prendra depuis le token
      const response = await axios.get(`/api/BillsValises/findBill`, {
        params: {
          billDate: invoiceDate,
          billNumber: invoiceNumber
          // 🔥 NE PAS envoyer locationId, le backend le récupère du token
        },
        headers: {
          'Authorised': localStorage.getItem('token') // 🔥 Le token contient l'info utilisateur
        }
      });

      console.log("📥 Réponse:", {
        success: response.data.success,
        billNumber: response.data.bill?.billNumber,
        location: response.data.bill?.locationName,
        userLocation: response.data.userLocation
      });

      if (response.data.success) {
        const formattedBill = {
          ...response.data.bill,
          items: response.data.bill.items?.map(item => ({
            _id: item._id || Math.random().toString(),
            name: item.name || 'Article inconnu',
            price: item.price || 0,
            quantity: item.quantity || 1,
            id: item.id?._id || item.id
          })) || []
        };

        setFoundBill(formattedBill);
        console.log("✅ Facture trouvée pour la bonne localisation:", formattedBill);

        alert(`✅ Facture N°${response.data.bill.billNumber} trouvée\n` +
          `Date: ${new Date(response.data.bill.date).toLocaleDateString()}\n` +
          `Localisation: ${response.data.bill.locationName || response.data.userLocation?.name}`);
      } else {
        setFoundBill(null);
        if (response.data.availableBills && response.data.availableBills.length > 0) {
          const billsList = response.data.availableBills
            .map(b => `N°${b.billNumber} - ${b.total.toFixed(2)} DT`)
            .join('\n');
          alert(`❌ Facture non trouvée.\n\nFactures disponibles dans VOTRE localisation:\n${billsList}`);
        } else {
          alert(`❌ ${response.data.message || "Aucune facture trouvée dans votre localisation pour cette date"}`);
        }
      }
    } catch (error) {
      console.error("❌ Erreur recherche facture:", {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        user: currentUser?.name
      });

      let errorMessage = "Erreur lors de la recherche";

      if (error.response?.status === 400) {
        errorMessage = error.response.data?.message || "Paramètres invalides ou localisation non définie";
      } else if (error.response?.status === 404) {
        if (error.response.data?.availableBills) {
          const billsList = error.response.data.availableBills
            .map(b => `N°${b.billNumber}`)
            .join(', ');
          errorMessage = `Facture non trouvée dans votre localisation. Disponibles: ${billsList}`;
        } else {
          errorMessage = error.response.data?.message || "Facture non trouvée";
        }
      } else if (error.response?.status === 401) {
        errorMessage = "Session expirée. Veuillez vous reconnecter.";
      }

      alert(`❌ ${errorMessage}`);
      setFoundBill(null);
    } finally {
      setSearchLoading(false);
    }
  };

  // Fonction pour ouvrir le modal d'annulation
  const openCancelModal = () => {
    setShowCancelModal(true);
    setAdminCode("");
    setCancelBarcodeInput("");
    setInvoiceNumber("");
    setInvoiceDate("");
    setCancelReason("");
    setFoundBill(null);
  };

  // 🔥 CORRECTION COMPLÈTE DE LA FONCTION D'ANNULATION
  const printCancelReceipt = (articleName) => {
    const locationName = currentUser?.localisation?.name || "Localisation inconnue";
    const cancellationDate = new Date().toLocaleString();

    const printableContent = `
      <div style="font-family:monospace; text-align:center; max-width:300px; margin:0 auto;">
        <h1 style="margin:0; font-size:18px;">${locationName.toUpperCase()}</h1>
        <h3 style="color:red; margin:10px 0;">AVIS D'ANNULATION</h3>
        <hr style="border:1px solid #000;"/>
        <div style="text-align:left; margin:10px 0;">
          <p style="margin:5px 0;"><strong>Facture annulée:</strong> ${foundBill.billNumber}</p>
          <p style="margin:5px 0;"><strong>Date d'achat:</strong> ${new Date(foundBill.date).toLocaleDateString()}</p>
          <p style="margin:5px 0;"><strong>Article annulé:</strong> ${articleName}</p>
          <p style="margin:5px 0;"><strong>Motif:</strong> ${cancelReason}</p>
          <p style="margin:5px 0;"><strong>Annulé par:</strong> Administrateur</p>
          <p style="margin:5px 0;"><strong>Date d'annulation:</strong> ${cancellationDate}</p>
        </div>
        <hr style="border:1px solid #000;"/>
        <div style="color:red; font-weight:bold; margin:10px 0;">
          ARTICLE ANNULÉ - STOCK RESTAURÉ
        </div>
        <div style="margin-top:20px; font-size:12px;">
          Merci de votre confiance
        </div>
      </div>
    `;

    const printWindow = window.open('', '', 'width=350,height=500,left=100,top=100');
    printWindow.document.write(`
      <html>
        <head>
          <title>Annulation Facture ${foundBill.billNumber}</title>
        </head>
        <body>
          ${printableContent}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ========================================
  // FONCTIONS POUR L'AJOUT DE POINTS
  // ========================================

  // Ouvrir le modal d'ajout de points
  const openPointsModal = () => {
    if (giftPointsTotal <= 0) {
      alert("⚠️ Aucun point cadeau dans cette addition");
      return;
    }
    setShowPointsModal(true);
    setPhoneNumber("");
    setClientName(""); // 🔥 AJOUT: Réinitialiser le nom du client
  };

  // Fermer le modal
  const closePointsModal = () => {
    setShowPointsModal(false);
    setPhoneNumber("");
    setClientName(""); // 🔥 AJOUT: Réinitialiser le nom du client
  };

  // 🔥 NOUVELLE FONCTION: Rechercher le client par téléphone
  const fetchClientByPhone = async (phone) => {
    if (!phone || phone.length < 8) {
      setClientName("");
      return;
    }

    try {
      setClientLoading(true);
      const response = await axios.get(`/api/admin/clients/by-phone/${phone}`);

      if (response.data.success && response.data.client) {
        setClientName(response.data.client.name);
      } else {
        setClientName("Client non trouvé");
      }
    } catch (error) {
      console.error("❌ Erreur recherche client:", error);
      if (error.response?.status === 404) {
        setClientName("Client non trouvé");
      } else {
        setClientName("");
      }
    } finally {
      setClientLoading(false);
    }
  };

  // Gérer le clavier numérique
  const handleNumericKeypad = async (value) => {
    if (value === 'delete') {
      const newPhone = phoneNumber.slice(0, -1);
      setPhoneNumber(newPhone);
      if (newPhone.length >= 8) {
        await fetchClientByPhone(newPhone);
      } else {
        setClientName("");
      }
    } else if (value === 'clear') {
      setPhoneNumber("");
      setClientName("");
      setIsPointsQueued(false);
    } else {
      if (phoneNumber.length < 15) { // Limite de 15 chiffres
        const newPhone = phoneNumber + value;
        setPhoneNumber(newPhone);
        if (newPhone.length >= 8) {
          await fetchClientByPhone(newPhone);
        }
      }
    }
  };

  // Confirmer UNITAQUEMENT la préparation des points (ne pas envoyer à l'API encore)
  const confirmAddPoints = () => {
    if (!phoneNumber || phoneNumber.length < 8) {
      alert("⚠️ Veuillez saisir un numéro de téléphone valide (minimum 8 chiffres)");
      return;
    }

    if (giftPointsTotal <= 0) {
      alert("⚠️ Aucun point à ajouter");
      return;
    }

    // 🔥 Changement: On ne fait que marquer les points comme "à envoyer"
    setIsPointsQueued(true);
    alert(`✅ Points préparés (${giftPointsTotal} pts) pour le client ${phoneNumber}.\nLes points seront réellement ajoutés après le succès du paiement.`);
    setShowPointsModal(false);
  };

  // 🔥 NOUVELLE FONCTION: Pour envoyer réellement les points après paiement
  const sendQueuedPoints = async (finalBillNumber) => {
    if (!isPointsQueued || !phoneNumber || giftPointsTotal <= 0) return;

    try {
      console.log("📤 Envoi RÉEL des points après paiement:", {
        phone: phoneNumber,
        points: giftPointsTotal,
        bill: finalBillNumber
      });

      const response = await axios.post('/api/admin/clients/add-points-by-phone', {
        phone: phoneNumber,
        points: giftPointsTotal,
        description: `Points ajoutés depuis ${currentUser?.localisation?.name || 'TASKO POS'} - Facture ${finalBillNumber}`,
        location: currentUser?.localisation?.name || 'TASKO POS'
      });

      if (response.data.success) {
        console.log("🎉 Points ajoutés avec succès via API Mes Kdo");
        // On pourrait afficher un petit toast discret ici
      } else {
        console.error("❌ Erreur API Mes Kdo:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Erreur lors de l'envoi différé des points:", error);
    } finally {
      // Réinitialiser la queue quoi qu'il arrive
      setIsPointsQueued(false);
      setPhoneNumber("");
    }
  };

  if (!currentUser) {
    return <div className="loading">Chargement des données utilisateur...</div>;
  }

  return (
    <div className="menu-container valises-pos">
      {/* AFFICHAGE NUMERO FACTURE EN COURS */}
      <div className="facture-badge" style={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        padding: '8px 12px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 1000
      }}>
        📍 {currentUser?.localisation?.name} - Facture N°: {nextBillNumber}
        <div style={{ fontSize: '12px', opacity: 0.9 }}>
          {new Date().toLocaleDateString()}
        </div>
      </div>


      <div className="menu-section">
        <div className="catego-buttons">
          {availableCategories.map((category) => (
            <button
              key={category}
              className={`catego-button ${selectedCategory === category ? "active" : ""}`}
              onClick={() => {
                setSelectedCategory(category);
                setSelectedProduct(null);
              }}
            >
              {category}
            </button>
          ))}
        </div>

        <h2 className="products-section-title">PRODUITS</h2>

        {selectedCategory === "SET" ? (
          <div className="sets-container">
            {(() => {
              const sets = menuData.filter((p) => p.category === "SET");
              const rows = [];
              for (let i = 0; i < sets.length; i += 6) {
                rows.push(sets.slice(i, i + 6));
              }

              return rows.map((row, rowIndex) => (
                <div key={rowIndex} className="product-row">
                  {row.map((setProduct) => (
                    <SetCardWithImage
                      key={setProduct._id}
                      setProduct={setProduct}
                      onSetClick={handleSetClick}
                    />
                  ))}
                </div>
              ));
            })()}
          </div>
        ) : selectedProduct ? (
          <div className="sub-product-container">
            {(() => {
              const product = menuData.find((p) => p._id === selectedProduct);
              const subProducts = product?.subProductsV || [];
              const rows = [];
              for (let i = 0; i < subProducts.length; i += 6) {
                rows.push(subProducts.slice(i, i + 6));
              }

              return rows.map((row, rowIndex) => (
                <div key={rowIndex} className="sub-product-row">
                  {row.map((subProduct) => (
                    <div
                      key={`${product._id}-${subProduct._id}`}
                      className="sub-product-card"
                      onClick={() =>
                        handleSubProductClick(
                          subProduct._id,
                          subProduct.name,
                          subProduct.price,
                          product._id,
                          subProduct.localisation || subProduct.localisations?.[0]
                        )
                      }
                    >
                      <div className="card-image-area">
                        {getImageSrc(subProduct.image) ? (
                          <img
                            src={getImageSrc(subProduct.image)}
                            alt=""
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                        ) : null}
                      </div>
                      <span className="sub-product-name">{subProduct.name}</span>
                      {subProduct.price != null && (
                        <span className="card-price">{Number(subProduct.price).toFixed(2)} DT</span>
                      )}
                      {subProduct.giftPoints > 0 && (
                        <div className="product-points-badge">
                          🎁 {subProduct.giftPoints}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ));
            })()}
          </div>
        ) : (
          <div className="products-container">
            {(() => {
              const toyCategories = ["TRANSPORT", "POUPEE", "EDUCATIFS", "METIERS", "BRICOLAGE", "PERSONNAGE", "ANIMAUX", "FILLETTE", "CUISINE", "MUSIQUE", "FIRSTAGE", "JOUETS"];
              const filteredProducts = menuData.filter(
                (product) => {
                  if (selectedCategory === "JOUETS") {
                    return toyCategories.includes(product.category);
                  }
                  return product.category === selectedCategory;
                }
              );
              const productRows = [];
              for (let i = 0; i < filteredProducts.length; i += 6) {
                productRows.push(filteredProducts.slice(i, i + 6));
              }

              return productRows.map((row, rowIndex) => (
                <div key={rowIndex} className="product-row">
                  {row.map((product) => {
                    const minPrice = product.subProductsV?.length
                      ? Math.min(...product.subProductsV.map((sp) => Number(sp.price) || 0))
                      : null;
                    return (
                      <div
                        key={product._id}
                        className="sub-product-card"
                        onClick={() => toggleSubProducts(product._id)}
                      >
                        <div className="card-image-area">
                          {getImageSrc(product.image) ? (
                            <img
                              src={getImageSrc(product.image)}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                          ) : null}
                        </div>
                        <span className="sub-product-name">{product.name}</span>
                        {minPrice != null && !isNaN(minPrice) && (
                          <span className="card-price">{minPrice.toFixed(2)} DT</span>
                        )}
                        {product.giftPoints > 0 && (
                          <div className="product-points-badge">
                            🎁 {product.giftPoints}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ));
            })()}
          </div>
        )}

        <div className="user-footer" style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "30px",
          padding: "4px 12px",
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #dee2e6",
        }}>
          <h6 style={{ margin: 0 }}>Bienvenue, {currentUser?.name || "Utilisateur"}!</h6>
          <h6 style={{ margin: 0 }}><strong>Localisation:</strong> {currentUser?.localisation?.name || "Non définie"}</h6>
          <h6 style={{ margin: 0 }}><strong>Rôle:</strong> {currentUser?.role}</h6>
        </div>
      </div>

      {/* Colonne Addition */}
      <div className="column addition-column">
        <div className="addition-section" style={{ marginTop: "0px", maxHeight: "calc(100vh - 80px)", overflowY: "auto", paddingBottom: "40px" }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Addition</h3>
            {giftPointsTotal > 0 && (
              <span style={{
                color: '#7B1FA2',
                fontSize: '14px',
                fontWeight: 'bold',
                backgroundColor: '#F3E5F5',
                padding: '2px 8px',
                borderRadius: '4px',
                border: '1px solid #7B1FA2'
              }}>
                🎁 {giftPointsTotal} pts
              </span>
            )}
          </div>

          {/* Champ Code-barres */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "15px" }}>
            <input
              type="text"
              className="valises-barcode-input"
              placeholder="Scanner ou saisir un code-barres..."
              value={barcodeInput}
              onChange={(e) => setBarcodeInput(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleManualBarcodeInput()}
              disabled={isScanning}
              style={{
                width: "100%",
                maxWidth: "320px",
                padding: "10px 14px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "16px",
                textAlign: "center",
                backgroundColor: isScanning ? "#f1f3f5" : "white",
                outline: "none",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease-in-out",
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
            <button
              onClick={openCancelModal}
              className="global-cancel-button"
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '4px 35px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                flex: 1
              }}
            >
              ❌ Annuler Article
            </button>

            <button
              className="valises-points-btn"
              onClick={openPointsModal}
              disabled={giftPointsTotal <= 0}
              style={{
                backgroundColor: isPointsQueued ? '#28a745' : (giftPointsTotal > 0 ? '#7B1FA2' : '#ccc'),
                color: 'white',
                border: 'none',
                padding: '4px 35px',
                borderRadius: '5px',
                cursor: giftPointsTotal > 0 ? 'pointer' : 'not-allowed',
                fontSize: '14px',
                fontWeight: 'bold',
                flex: 1,
                boxShadow: isPointsQueued ? '0 0 10px rgba(40, 167, 69, 0.5)' : 'none'
              }}
            >
              {isPointsQueued ? `✅ Points OK (${phoneNumber})` : "🎁 Ajouter Les Points"}
            </button>
          </div>

          {additionItems.length === 0 ? (
            <p>Aucun article sélectionné. Scannez un code-barres pour commencer.</p>
          ) : (
            <>
              <table className="addition-table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Prix</th>
                    <th>Quantité</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {additionItems?.map((item) => (
                    <tr key={item.id}>
                      <td>
                        {item.name}
                        {item.isDeal && (
                          <div style={{ marginLeft: "15px", fontSize: "0.9em", color: "#666" }}>
                            {item.subProducts?.map((sp) => `• ${sp.name}`).join(", ")}
                          </div>
                        )}
                      </td>
                      <td>{item.price?.toFixed(2)} DT</td>
                      <td>
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) => modifyItem(item.id, parseInt(e.target.value))}
                          style={{ width: "50px" }}
                        />
                      </td>
                      <td>{(item.price * item.quantity).toFixed(2)} DT</td>
                      <td>
                        <button onClick={() => deleteItem(item.id)}>X</button>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan="3">Total HT</td>
                    <td colSpan="2">{calculateTotal()} DT</td>
                  </tr>
                  <tr>
                    <td colSpan="3">TVA</td>
                    <td colSpan="2">{calculateTva()} DT</td>
                  </tr>
                  <tr>
                    <td colSpan="3">Total TTC</td>
                    <td colSpan="2">{calculateTotalTTC()} DT</td>
                  </tr>
                  {giftPointsTotal > 0 && (
                    <tr style={{ backgroundColor: '#F3E5F5', fontWeight: 'bold', color: '#7B1FA2' }}>
                      <td colSpan="3">🎁 Total Points Cadeaux</td>
                      <td colSpan="2">{giftPointsTotal} pts</td>
                    </tr>
                  )}
                </tfoot>
              </table>

              {/* Section Réduction Dynamique par Localisation */}
              <div className="discount-section" style={{ background: "#f8fafc", padding: "10px", borderRadius: "10px", border: "1px solid #e2e8f0", marginBottom: "12px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <strong style={{ fontSize: "13px", color: "#1e293b" }}>🏷️ Remises & Promotions :</strong>
                  {discount > 0 && (
                    <span style={{ background: "#ecfdf5", color: "#047857", fontWeight: "bold", fontSize: "12px", padding: "2px 8px", borderRadius: "6px", border: "1px solid #10b981" }}>
                      -{discount}% ({selectedDiscount ? selectedDiscount.name : `${discount}%`})
                    </span>
                  )}
                </div>
                <div className="discount-buttons" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px", width: "100%" }}>
                  {availableDiscounts.length === 0 ? (
                    <span style={{ fontSize: "12px", color: "#64748b", fontStyle: "italic", gridColumn: "span 2" }}>
                      Aucune remise active pour cette boutique
                    </span>
                  ) : (
                    availableDiscounts.map((d) => {
                      const isSelected = selectedDiscount?._id === d._id || discount === d.percentage;
                      return (
                        <button
                          key={d._id}
                          type="button"
                          onClick={() => {
                            if (selectedDiscount?._id === d._id || discount === d.percentage) {
                              setSelectedDiscount(null);
                              setDiscount(0);
                            } else {
                              setSelectedDiscount(d);
                              setDiscount(d.percentage);
                            }
                          }}
                          className={isSelected ? "selected" : ""}
                          style={{
                            width: "100%",
                            minHeight: "44px",
                            padding: "8px 10px",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            fontSize: "12px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            lineHeight: "1.2",
                            backgroundColor: isSelected ? "#059669" : (d.type === 'permanent' ? "#e0f2fe" : "#fef3c7"),
                            color: isSelected ? "#ffffff" : (d.type === 'permanent' ? "#0369a1" : "#b45309"),
                            border: isSelected ? "1.5px solid #047857" : "1px solid #cbd5e1",
                            boxShadow: isSelected ? "0 2px 6px rgba(5,150,105,0.3)" : "none"
                          }}
                          title={d.name}
                        >
                          {d.type === "permanent" ? "🌟" : "🎉"} {d.name} ({d.percentage}%) {isSelected ? "✓" : ""}
                        </button>
                      );
                    })
                  )}
                </div>
              </div>

              <div className="confirm-buttons">
                <button
                  onClick={confirmAddition}
                  disabled={!additionItems.length || loading}
                  className="confirm-addition-button"
                >
                  {loading ? "⏳ Traitement..." : "💳 Payer"}
                </button>

              </div>

              <div className="payment-section">
                <h5>Paiement</h5>
                <div className="payment-buttons">
                  {["Espece", "TPE"].map((method) => (
                    <button
                      key={method}
                      onClick={() => handlePaymentMethod(method)}
                      className={paymentMethod === method ? "selected" : ""}
                      disabled={!additionItems.length}
                    >
                      {method}
                    </button>
                  ))}
                </div>
                {!paymentMethod && (
                  <p className="error-message">Sélectionnez un mode de paiement</p>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Modal d'Annulation d'Article */}
      {showCancelModal && (
        <div className="modal-overlay" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
          alignItems: 'center', zIndex: 2000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '8px',
            maxWidth: '500px', width: '90%', maxHeight: '90vh', overflowY: 'auto'
          }}>
            <h3>Annulation d'Article</h3>

            {/* RECHERCHE FACTURE */}
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label>Date de la facture (YYYY-MM-DD):</label>
              <input
                type="date"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label>Numéro de Facture:</label>
              <input
                type="text"
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
                placeholder="Ex: 001, 002, etc."
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <button
              onClick={searchBill}
              disabled={searchLoading || !invoiceDate || !invoiceNumber}
              style={{
                backgroundColor: '#17a2b8', color: 'white', border: 'none',
                padding: '8px 15px', borderRadius: '4px', cursor: 'pointer',
                marginBottom: '15px', width: '100%'
              }}
            >
              {searchLoading ? "🔍 Recherche..." : "🔍 Rechercher la Facture"}
            </button>

            {foundBill && (
              <div style={{
                backgroundColor: '#d4edda', padding: '10px', borderRadius: '4px',
                marginBottom: '15px', border: '1px solid #c3e6cb'
              }}>
                <strong>✅ Facture trouvée:</strong><br />
                N°: {foundBill.billNumber} |
                Date: {new Date(foundBill.date).toLocaleDateString()} |
                Total: {foundBill.total} DT
              </div>
            )}

            {/* CODE ADMIN ET SÉLECTION ARTICLE */}
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label>Code Administrateur:</label>
              <input
                type="password"
                value={adminCode}
                onChange={(e) => setAdminCode(e.target.value)}
                placeholder="Entrez le code admin"
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            {foundBill && (
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label>Sélectionnez l'article à annuler:</label>
                <select
                  value={cancelBarcodeInput}
                  onChange={(e) => setCancelBarcodeInput(e.target.value)}
                  style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                  <option value="">Choisissez un article</option>
                  {foundBill.items.map((item, index) => (
                    <option key={index} value={item._id}>
                      {item.name} - {item.price} DT x {item.quantity}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label>Motif d'annulation:</label>
              <select
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              >
                <option value="">Sélectionnez un motif</option>
                <option value="retour_produit">Retour produit défectueux</option>
                <option value="changement_produit">Changement de produit</option>
                <option value="erreur_commande">Erreur de commande</option>
                <option value="client_insatisfait">Client insatisfait</option>
                <option value="autre">Autre raison</option>
              </select>
            </div>

            <div className="modal-buttons" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                onClick={cancelArticle}
                disabled={!adminCode || !cancelBarcodeInput || !cancelReason || !foundBill || loading}
                className="confirm-button"
                style={{
                  backgroundColor: '#28a745', color: 'white', border: 'none',
                  padding: '10px 15px', borderRadius: '5px', cursor: 'pointer'
                }}
              >
                {loading ? "⏳ Traitement..." : "✅ Confirmer l'annulation"}
              </button>
              <button
                onClick={() => {
                  setShowCancelModal(false);
                  setFoundBill(null);
                  setInvoiceDate("");
                  setInvoiceNumber("");
                  setCancelBarcodeInput("");
                  setCancelReason("");
                  setAdminCode("");
                }}
                className="cancel-button"
                style={{
                  backgroundColor: '#6c757d', color: 'white', border: 'none',
                  padding: '10px 15px', borderRadius: '5px', cursor: 'pointer'
                }}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'Ajout de Points */}
      {showPointsModal && (
        <div className="modal-overlay" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
          alignItems: 'center', zIndex: 2000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '10px',
            maxWidth: '400px', width: '90%', maxHeight: '95vh', boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            <h3 style={{
              textAlign: 'center',
              color: '#7B1FA2',
              marginBottom: '12px',
              marginTop: '0',
              fontSize: '20px'
            }}>
              🎁 Ajouter Les Points
            </h3>

            {/* Affichage du nombre de points */}
            <div style={{
              backgroundColor: '#F3E5F5',
              padding: '12px',
              borderRadius: '6px',
              textAlign: 'center',
              marginBottom: '12px',
              border: '2px solid #7B1FA2'
            }}>
              <div style={{ fontSize: '13px', color: '#666', marginBottom: '3px' }}>
                Points de cette addition
              </div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#7B1FA2' }}>
                {giftPointsTotal} pts
              </div>
            </div>

            {/* Champ d'affichage du numéro */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '13px' }}>
                Numéro de téléphone :
              </label>
              <input
                type="text"
                value={phoneNumber}
                readOnly
                placeholder="Utilisez le clavier"
                style={{
                  width: '100%',
                  padding: '10px',
                  fontSize: '18px',
                  textAlign: 'center',
                  borderRadius: '6px',
                  border: '2px solid #7B1FA2',
                  backgroundColor: '#f9f9f9',
                  letterSpacing: '2px',
                  fontWeight: 'bold',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {/* 🔥 NOUVEAU: Affichage du nom du client */}
            {phoneNumber.length >= 8 && (
              <div style={{
                marginBottom: '12px',
                padding: '10px',
                backgroundColor: clientName && clientName !== "Client non trouvé" ? '#e8f5e9' : '#fff3e0',
                borderRadius: '6px',
                border: `2px solid ${clientName && clientName !== "Client non trouvé" ? '#4caf50' : '#ff9800'}`,
                textAlign: 'center'
              }}>
                {clientLoading ? (
                  <span style={{ color: '#666', fontSize: '14px' }}>🔍 Recherche...</span>
                ) : clientName ? (
                  <div>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '3px' }}>Client :</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold', color: clientName === "Client non trouvé" ? '#f57c00' : '#2e7d32' }}>
                      {clientName === "Client non trouvé" ? "❌ " + clientName : "✅ " + clientName}
                    </div>
                  </div>
                ) : null}
              </div>
            )}

            {/* Clavier numérique */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '8px',
              marginBottom: '12px'
            }}>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                <button
                  key={num}
                  onClick={() => handleNumericKeypad(num.toString())}
                  style={{
                    padding: '15px 10px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    backgroundColor: '#f0f0f0',
                    border: '2px solid #ddd',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7B1FA2';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f0f0f0';
                    e.target.style.color = 'black';
                  }}
                >
                  {num}
                </button>
              ))}

              <button
                onClick={() => handleNumericKeypad('clear')}
                style={{
                  padding: '15px 10px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  backgroundColor: '#ff9800',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                C
              </button>

              <button
                onClick={() => handleNumericKeypad('0')}
                style={{
                  padding: '15px 10px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  backgroundColor: '#f0f0f0',
                  border: '2px solid #ddd',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#7B1FA2';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#f0f0f0';
                  e.target.style.color = 'black';
                }}
              >
                0
              </button>

              <button
                onClick={() => handleNumericKeypad('delete')}
                style={{
                  padding: '15px 10px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                ⌫
              </button>
            </div>

            {/* Boutons d'action */}
            <div style={{ display: 'flex', gap: '8px', marginTop: '0' }}>
              <button
                onClick={confirmAddPoints}
                disabled={pointsLoading || !phoneNumber || phoneNumber.length < 8}
                style={{
                  flex: 1,
                  backgroundColor: (!phoneNumber || phoneNumber.length < 8) ? '#ccc' : '#28a745',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '6px',
                  cursor: (!phoneNumber || phoneNumber.length < 8) ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                {pointsLoading ? '⏳ Envoi...' : '✅ Confirmer'}
              </button>

              <button
                onClick={closePointsModal}
                disabled={pointsLoading}
                style={{
                  flex: 1,
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '12px',
                  borderRadius: '6px',
                  cursor: pointsLoading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Valises;
